// Function to validate the form
export const validateForm = (formData) => {
    const errors = {};

    // URL validation
    if (!formData.AptURL) {
        errors.AptURL = 'Apartment URL is required';
    } else if (!/^https?:\/\/.+/.test(formData.AptURL)) {
        errors.AptURL = 'Please enter a valid URL starting with http:// or https://';
    }

    // Apartment Name validation
    if (!formData.AptName) {
        errors.AptName = 'Apartment Name is required';
    } else if (formData.AptName.length < 2 || formData.AptName.length > 100) {
        errors.AptName = 'Apartment Name must be between 2 and 100 characters';
    }

    // Floor Plan validation
    if (!formData.AptFP) {
        errors.AptFP = 'Apartment Floor Plan is required';
    } else if (formData.AptFP.length < 1 || formData.AptFP.length > 5) {
        errors.AptFP = 'Floor Plan must be between 1 and 5 characters';
    }

    // Unit Number validation
    if (!formData.AptUN) {
        errors.AptUN = 'Apartment Unit Number is required';
    } else if (formData.AptUN.length < 1 || formData.AptUN.length > 20) {
        errors.AptUN = 'Unit Number must be between 1 and 20 characters';
    }

    // Price validation
    if (!formData.AptPrice) {
        errors.AptPrice = 'Ideal Monthly Lease Price is required';
    } else if (isNaN(formData.AptPrice) || Number(formData.AptPrice) < 100 || Number(formData.AptPrice) > 100000) {
        errors.AptPrice = 'Please enter a valid price between $100 and $100,000';
    }

    // Lease Start Date validation
    if (!formData.leaseStart) {
        errors.leaseStart = 'Ideal Lease Start Date is required';
    }

    // Email validation
    if (!formData.AptEmail) {
        errors.AptEmail = 'Email Address is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.AptEmail)) {
        errors.AptEmail = 'Please enter a valid email address';
    }

    return errors;
};
  
// Function to encrypt data
export const encryptData = (data) => {
return btoa(JSON.stringify(data));
};

// Function to generate a unique ID
export const generateLZID = () => {
const randomNumbers = Math.floor(Math.random() * 100000000).toString().padStart(8, '0');
return 'LZID' + randomNumbers;
};

// Function to format the date from YYYY-MM-DD to MM-DD-YYYY
export const formatDate = (dateInput) => {
const [year, month, day] = dateInput.split('-');
return `${month}-${day}-${year}`;
};

// Function to extract requestor name from email
export const extractRequestorName = (email) => {
return email
    .split('@')[0]           // Get text before @
    .replace(/[0-9]/g, '')   // Remove all numbers
    .replace(/[._-]/g, ' ')  // Replace dots, underscores, hyphens with spaces
    .trim();                 // Remove extra spaces
};
